/* eslint-disable max-len */
import React from 'react';

type Props = { className?: string };

// Tick + purple ring lifted from Figma "Small Popover" (40000840:35210).
// viewBox covers the bounding box of the original paths so the icon scales to its container.
export const SuccessTickIcon = ({ className }: Props) => (
  <svg
    className={className}
    viewBox="160 350 105 110"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M221.139 356.964C222.135 357.164 222.782 358.113 222.584 359.083C222.385 360.054 221.416 360.681 220.419 360.481C212.251 358.847 203.658 359.523 195.813 362.438L194.255 363.052C185.008 366.892 177.229 373.814 172.366 382.545C166.579 392.936 165.219 404.928 168.535 416.326C171.85 427.724 179.433 437.141 189.889 442.864C194.188 445.217 198.754 446.827 203.436 447.68L204.699 447.892C211.023 448.858 217.547 448.458 223.891 446.641C235.371 443.353 244.879 435.833 250.666 425.443C255.413 416.92 257.194 407.102 255.779 397.527C255.634 396.546 256.332 395.641 257.337 395.505C258.344 395.37 259.278 396.056 259.423 397.038C260.951 407.376 259.029 417.971 253.905 427.171C247.661 438.382 237.374 446.527 224.948 450.085C217.63 452.181 210.072 452.54 202.78 451.209C198.014 450.341 193.368 448.751 188.976 446.46L188.102 445.992C176.779 439.794 168.572 429.592 164.993 417.288C161.414 404.985 162.883 392.027 169.126 380.816C174.378 371.388 182.78 363.906 192.794 359.747L192.796 359.748C201.736 356.037 211.691 355.073 221.139 356.964Z"
      fill="#573A78"
    />
    <path
      d="M192.186 402.824C191.68 402.296 191.946 401.259 192.78 400.508C193.614 399.757 194.699 399.577 195.204 400.105L212.284 417.957C212.789 418.485 212.523 419.522 211.689 420.273C210.856 421.023 209.77 421.204 209.265 420.676L192.186 402.824Z"
      fill="#E516C5"
    />
    <path
      d="M214.053 418.939C212.671 420.468 210.857 421.114 210.001 420.382C209.144 419.651 209.569 417.818 210.95 416.289L257.633 364.617C259.014 363.088 260.828 362.442 261.685 363.174C262.541 363.905 262.116 365.738 260.735 367.267L214.053 418.939Z"
      fill="#E516C5"
    />
  </svg>
);

export default SuccessTickIcon;
